import * as React from 'react';
import * as styles from "./Settings.css";
import { AppStore } from '../stores';
import { inject, observer } from 'mobx-react';
import { LocalizationService } from '../../../services/LocalizationService';
import { MenuItem } from '../menu/menuItem/MenuItem';
import NativeService from '../../../services/NativeService';
const PACKAGE = require("../../../../package.json")

export interface ISettingsProps {
  store?: AppStore;
  show: boolean;
  switchApp?: () => void;
  logOut?: () => void;
}


@inject('store')
@observer
export class Settings extends React.Component<ISettingsProps> {

  private localizationService: LocalizationService = new LocalizationService();

  constructor(props: ISettingsProps) {
    super(props);
    this.state = {
      position: "-85%",
      display: "none"
    }
    this.localizationService?.checkLocalizedStrings().then(() => this.forceUpdate());
  }

  public render(): JSX.Element {
    return (
      <div
        style={{
          width: "100%",
          height: "100%",
          overflow: "hidden"
        }}
      >
        <div
          className={styles.IA_menu}
          style={{
            display: this.props.store.showSettings ? "block" : "none"
          }}
          onClick={() => {
            this.props.store.showSettings = false;
          }}
        />
        <div
          className={styles.IA_menuPanel}
          style={{
            backgroundColor: this.props.store.instance.settings.design.menuColor,
            right: this.props.store.showSettings ? 0 : "-85%",
            top: window.platform === "android" ? 50 : this.props.store.isIPhoneXType ? 90 : 70,
            height: `calc(100% - ${window.platform === "android" ? 0 : this.props.store.isIPhoneXType ? 40 : 20}px)`
          }}
        >
          <MenuItem
            key={"LogOut"}
            icon={"LogOut"}
            title={this.localizationService.strings.App_LogOut}
            iconColor={this.props.store.instance.settings.design.menuContentColor}
            titleColor={this.props.store.instance.settings.design.menuContentColor}
            onClick={() => {
              this.props.logOut();
            }}
          />
          {(!this.props.store.isCustomApp || this.props.store.tenant.replace(".sharepoint.com", "") === "applusglobal") &&
            <MenuItem
              key={"Synchronize"}
              icon={"Synchronize"}
              title={this.localizationService.strings.App_SwitchApp}
              iconColor={this.props.store.instance.settings.design.menuContentColor}
              titleColor={this.props.store.instance.settings.design.menuContentColor}
              onClick={() => {
                this.props.switchApp();
              }}
            />
          }
          {NativeService.hasCustomIcon(this.props.store.tenant) && !this.props.store.isCustomApp &&
            <div className={styles.IA_iconSelector}>
              <div className={styles.IA_iconSelectorTitle}>
                {this.localizationService.strings.App_SelectAppIcon}
              </div>
              <div
                className={styles.IA_icon}
                style={{
                  backgroundImage: `URL(https://intraactivestorage.blob.core.windows.net/cdn/tenants/intraactive/icon.png)`,
                  left: "15%",
                }}
                onClick={() => NativeService.resetIcon()}
              />
              <div
                className={styles.IA_icon}
                style={{
                  backgroundImage: `URL(https://intraactivestorage.blob.core.windows.net/cdn/tenants/${this.props.store.tenant}/icon.png)`,
                  right: "15%",
                }}
                onClick={() => NativeService.changeIcon(this.props.store.tenant)}
              />
            </div>
          }
          <div
            className={styles.IA_version}
            style={{
              color: this.props.store.instance.settings.design.menuContentColor
            }}
          >
            <div style={{ fontWeight: "bold", letterSpacing: 1 }}>INTRAACTIVE APP</div>
            <div >{this.props.store.nativeVersion ? `version ${PACKAGE.version} / ${this.props.store.nativeVersion}` : `version ${PACKAGE.version}`}</div>
          </div>
        </div>
      </div>
    );
  }
}